import { createFileRoute } from "@tanstack/react-router";
import { AgendaShell } from "@/components/agenda/agenda-shell";
import { AgendaGestaoChips } from "@/components/agenda/agenda-gestao-chips";

export const Route = createFileRoute("/agenda/gestao-chips")({
  component: () => (
    <AgendaShell>
      <AgendaGestaoChips />
    </AgendaShell>
  ),
  head: () => ({ meta: [{ title: "Gestão de Chips — Agenda — GPS Drive" }] }),
});
